import React from 'react';

interface ShimmerBoxProps {
  className?: string;
}

export const ShimmerBox: React.FC<ShimmerBoxProps> = ({ className = '' }) => (
  <div className={`shimmer-bg rounded ${className}`} />
);

export const ProductCardSkeleton: React.FC = () => (
  <div className="bg-white rounded-xl overflow-hidden shadow-sm border border-gray-100">
    <ShimmerBox className="w-full h-48 md:h-56" />
    <div className="p-4 space-y-3">
      <ShimmerBox className="h-4 w-3/4" />
      <ShimmerBox className="h-3 w-1/2" />
      <ShimmerBox className="h-5 w-1/3" />
      <ShimmerBox className="h-10 w-full mt-2" />
    </div>
  </div>
);

export const ProductDetailSkeleton: React.FC = () => (
  <main className="max-w-6xl mx-auto">
    <div className="mb-6">
      <ShimmerBox className="h-4 w-24" />
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
      <div className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100">
        <ShimmerBox className="w-full h-64 md:h-96" />
      </div>
      <div className="space-y-8">
        <div className="space-y-4">
          <ShimmerBox className="h-4 w-32" />
          <ShimmerBox className="h-8 w-3/4" />
          <ShimmerBox className="h-6 w-1/4" />
        </div>
        <div className="space-y-2">
          <ShimmerBox className="h-4 w-full" />
          <ShimmerBox className="h-4 w-full" />
          <ShimmerBox className="h-4 w-2/3" />
        </div>
        <ShimmerBox className="h-14 w-full rounded-xl" />
      </div>
    </div>
  </main>
);

export const CategoryPageSkeleton: React.FC<{ count?: number }> = ({ count = 8 }) => (
  <main>
    <ShimmerBox className="h-9 w-48 mb-8" />
    <div className="flex flex-wrap gap-2 sm:gap-4 mb-8">
      {[...Array(4)].map((_, i) => (
        <ShimmerBox key={i} className="h-10 w-20 sm:w-32 rounded-full" />
      ))}
    </div>
    <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
      {[...Array(count)].map((_, i) => (
        <ProductCardSkeleton key={i} />
      ))}
    </div>
  </main>
);

export const HomeSkeleton: React.FC = () => (
  <main className="space-y-8 md:space-y-12">
    <section className="relative rounded-2xl overflow-hidden bg-slate-900 min-h-[350px] md:min-h-[550px]">
      <ShimmerBox className="absolute inset-0" />
    </section>
    <section className="py-4">
      <ShimmerBox className="h-7 w-48 mb-6 md:mb-8" />
      <div className="flex overflow-x-auto gap-4 pb-4 sm:grid sm:grid-cols-3 sm:pb-0 md:gap-6">
        {[...Array(3)].map((_, i) => (
          <div key={i} className="rounded-xl border-2 p-6 md:p-8 flex-shrink-0 min-w-[70vw] sm:min-w-0 shimmer-bg" />
        ))}
      </div>
    </section>
    <section>
      <div className="flex flex-row items-center justify-between mb-6 md:mb-8">
        <ShimmerBox className="h-7 w-32" />
        <ShimmerBox className="h-5 w-24" />
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {[...Array(4)].map((_, i) => (
          <ProductCardSkeleton key={i} />
        ))}
      </div>
    </section>
  </main>
);